import type { StreamError, StreamEvent, StreamFormattedChunk, StreamingResponse } from './types';

/**
 * `formatStreamResponse` (and its `splitBufferedText` helper) now live in `@lumapps/base-api`, so
 * `base-api` no longer depends on `streaming`. Re-exported here to keep the public
 * `@lumapps/streaming/utils` entry point stable for existing consumers.
 */
export { formatStreamResponse, splitBufferedText } from '@lumapps/base-api/streaming/utils';

/**
 * Check if the data returned by the stream are errors
 */
export function isStreamError<E extends StreamError>(stream: any): stream is StreamFormattedChunk<E> {
    return 'errors' in stream;
}

/**
 * Check if the data returned by the stream are data
 */
export function isStreamData<E extends StreamEvent>(stream: any): stream is StreamFormattedChunk<E> {
    return 'data' in stream;
}

/** Read the given stream async generator and call the given callback when each chunk is received  */
export const readStreamGenerator = async <Events extends StreamEvent>(
    stream: AsyncGenerator<StreamingResponse<Events>>,
    onChunkDownload: (chunk: StreamingResponse<Events>) => void,
    onError?: (error: unknown) => void,
) => {
    try {
        for await (const chunks of stream) {
            onChunkDownload(chunks);
        }
    } catch (error) {
        // Catch fails (e.g. API GW closes the connection)
        onError?.(error);
    }
};
